import CashCtrlLogo from "@/components/logos/CashCtrlLogo";

const CoinStack = () => {
    return (
        <div className="aspect-square relative w-full">
            <div className="absolute w-full z-0">
                <CashCtrlLogo className="w-full h-auto" />
            </div>
            <div className="absolute w-full z-10" style={{ bottom: "13.4%", right: "-5.5%" }}>
                <CashCtrlLogo className="w-full h-auto" />
            </div>
            <div className="absolute w-full z-20" style={{ bottom: "24.7%", right: "-0.6%" }}>
                <CashCtrlLogo className="w-full h-auto" />
            </div>
        </div>
    );
};

export default CoinStack;
